module.exports = __webpack_public_path__ + "img/letter_icon3.360bc59f.png";